import React from "react";
import { Button, Typography } from "antd";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import useNotebookStore from "../../store/useNotebookStore";

const { Title } = Typography;

const NotebookHeader = ({ refs }) => {
  const { 
    notebookList, setNotebookList, 
    setViewingNotebook, setEditingNotebook, 
    setCards, cardTitle, isEditing
  } = useNotebookStore();

  const handleAddNotebook = () => {
    if (isEditing) {
      return;
    }

    const newNotebook = {
      id: uuidv4(),
      date: moment().format("YYYY-MM-DD HH:mm:ss"),
      title: cardTitle,
      cards: [
        {
          id: uuidv4(),
          content: "",
          kor: "",
          img: "error",
          audio: "",
        },
      ],
    };

    const updatedNotebookList = [newNotebook, ...notebookList];
    setNotebookList(updatedNotebookList);
    setEditingNotebook(0);
    setViewingNotebook(null);
    setCards(newNotebook.cards);
  };

  const { ref2 } = refs;

  return (
    <div className="flex justify-between">
      <Title level={5}>수첩 리스트</Title>
      <div className="flex items-center gap-5">
        <Button
          ref={ref2}
          onClick={handleAddNotebook}
          className={`px-[30px] border border-[#3D90EF] ${
            isEditing ? "text-[#ccc]" : "text-[#3D90EF]"
          }`}
          disabled={isEditing}
        >
          수첩 추가하기
        </Button>

        {/* <Button
          className="text-[#3D90EF] border border-[#3D90EF]"
          onClick={() => setFileUploadModal(true)}
        >
          수첩 불러오기
        </Button> */}
      </div>
    </div>
  );
};

export default NotebookHeader;
